import {DeleteFakturierungsbelegDialogState} from '../states/delete-fakturierungsbeleg-dialog.state';
import {createReducer, on} from '@ngrx/store';
import {DeleteFakturierungsbelegDialogActions} from '../actions/delete-fakturierungsbeleg-dialog.actions';


export const initialDeleteFakturierungsbelegDialogState: DeleteFakturierungsbelegDialogState = {
  isOpen: false,
};

export const deleteFakturierungsbelegDialogReducer = createReducer(
  initialDeleteFakturierungsbelegDialogState,

  on(
    DeleteFakturierungsbelegDialogActions.open,
    (state, action) => ({
      ...state,
      isOpen: true,
      belegId: action.belegId,
      betriebId: action.betriebId,
    })
  ),

  on(
    DeleteFakturierungsbelegDialogActions.close,
    () => ({
      ...initialDeleteFakturierungsbelegDialogState,
    })
  ),
);
